import { paymentStatementApi } from './base';

export const salesforceApi = paymentStatementApi.injectEndpoints({
	endpoints: (builder) => ({
		finishSalesforceConnect: builder.mutation<
			unknown,
			{ code: string; state: string }
		>({
			query: (body) => ({
				url: '/salesforce/connection',
				method: 'POST',
				body,
			}),
		}),
	}),
});

export const { useFinishSalesforceConnectMutation } = salesforceApi;
